// Display stock availability for bundled products
function get_slot_date_stock(slot_date_element, event) {
  const parent_result = jQuery(slot_date_element).attr('id').split('_');
  const slot_id = jQuery(slot_date_element).parent().parent().attr('data-id');
  const slot_date_selected = slot_date_element.find(':selected').val();
  const info_element = `#fooevents-checkout-attendee-info-val-field-${slot_id}`;

  // Don't show stock count for 'Select Session'
  if (slot_date_selected == '') {
    jQuery(info_element).css('display', 'none');
  } else {
    jQuery(info_element).css('display', 'block');
  }

  const data_slot_date_stock = {
    action: 'fetch_fooevents_bookings_slot_date_stock',
    slot_date_selected: slot_date_selected,
  };

  jQuery.post(
    FooEventsBookingsFrontObj.ajaxurl,
    data_slot_date_stock,
    function (response) {
      const returned_stock = JSON.parse(response);
      jQuery(info_element).html(returned_stock.stock);

      jQuery(`#fooevents-bookings-stock-${slot_id}`).val(
        returned_stock.stock_val
      );
      jQuery('.qty').attr('max', returned_stock.stock_val);
      let unavailableSlot = false;

      // Make sure all selected booking slots aren't sold out
      document
        .querySelectorAll('.fooevents-checkout-attendee-info')
        .forEach((stock) => {
          if (stock.innerText == 'Availability: 0') {
            unavailableSlot = true;
            jQuery("button[name='register-now']").addClass('unavailable-slot');
          }
        });

      if (unavailableSlot || returned_stock.stock_val == 0) {
        jQuery("button[name='register-now']").attr('disabled', true);
      } else {
        jQuery("button[name='register-now']").attr('disabled', false);
        jQuery("button[name='register-now']").removeClass('unavailable-slot');
      }
    }
  );
}

export const eventStock = () => {
  if (document.querySelector('.woosb-bundled')) {
    document
      .querySelectorAll('.fooevents-checkout-attendee-info')
      .forEach((div) => {
        const id = div.parentElement.parentElement.getAttribute('data-id');
        div.id = div.id + '-' + id;
      });

    document.querySelectorAll('.fooevents-bookings-stock').forEach((input) => {
      const id = input.parentElement.parentElement.getAttribute('data-id');
      input.id = input.id + '-' + id;
    });

    document
      .querySelector("button[name='register-now']")
      .classList.remove('single_add_to_cart_button');

    if (jQuery('.fooevents-bookings-slot-date').length) {
      jQuery('.fooevents-bookings-slot-date').on('change', function (event) {
        const slot_date_element = jQuery(this);
        get_slot_date_stock(slot_date_element, event);
      });
    }
  }

  // Hide stock notice when no booking slot is selected for non-bundle events
  else if (
    document.querySelector('.summary .fooevents-checkout-attendee-info')
  ) {
    if (jQuery('.fooevents-bookings-slot-date').length) {
      jQuery('.fooevents-bookings-slot-date').on('change', function (event) {
        const slot_date_selected = jQuery(this).find(':selected').val();
        const info_element = '#fooevents-checkout-attendee-info-val-field';

        if (slot_date_selected == '') {
          jQuery(info_element).css('display', 'none');
        } else {
          jQuery(info_element).css('display', 'block');
        }
      });
    }
  }

  // Disable register button when waiting for AJAX call
  if (document.querySelector('.fooevents-checkout-attendee-info')) {
    document.querySelectorAll('p.attendee-class select').forEach((select) => {
      select.addEventListener('change', (e) => {
        document
          .querySelector("button[name='register-now']")
          .setAttribute('disabled', true);
      });
    });
  }
};
